export default {
	id: 'SIMPLE_WORKBOOK_BUNDLE_90',
	providers: {
		paltaMap: {},
	},
	otp: {
		priceMap: {
			USD: 90,
			EUR: 90,
			GBP: 90,
			AUD: 115,
			CAD: 115,
			DKK: 800,
			SEK: 1000,
			NOK: 910,
			BRL: 319,
			MXN: 1480,
			TRY: 3099,
			ARS: 116990,
			COP: 359990,
			CLP: 80990,
		},
	},
}
